// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style-module__breadcrumbs___371M_"};